export default "__VITE_ASSET__D345_ZnL__"